import { useQuery, useQueryClient } from "@tanstack/react-query";
import { directorApprovalsApi } from "../api/directorApprovals";

export const DIRECTOR_APPROVALS_KEY = ["director-approvals"] as const;

export function useDirectorApprovals(allFees: boolean) {
  return useQuery({
    queryKey: [...DIRECTOR_APPROVALS_KEY, { allFees }],
    queryFn: () => directorApprovalsApi.list(allFees),
    // Pozycje rozstrzyga się także w ich modułach (i robią to inni) — zawsze świeże.
    staleTime: 0,
    refetchOnMount: "always",
  });
}

/** Odświeża tabelę po decyzji podjętej z niej samej. */
export function useInvalidateDirectorApprovals() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: DIRECTOR_APPROVALS_KEY });
}
